import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=35bb3fcc&scoped=true&"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js&"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=35bb3fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb3fcc",
  null
  
)

export default component.exports